export enum ServerMethods {
  joinGroup = 'JoinGroup',
  joinTenantGroup = 'JoinTenantGroup',
  leaveGroup = 'LeaveGroup',
  leaveTenantGroup = 'LeaveTenantGroup',
  addStudentPOEAnnotation = 'AddStudentPOEAnnotation',
  deleteStudentPOEAnnotation = 'DeleteStudentPOEAnnotation',
  addProgrammePOEAnnotation = 'AddProgrammePOEAnnotation',
  editPOEAnnotation = 'EditPOEAnnotation',
  deleteProgrammePOEAnnotation = 'DeleteProgrammePOEAnnotation',
  addPOEInput = 'AddPOEInput',
  deletePOEInput = 'DeletePOEInput',
  editPOEInput = 'EditPOEInput',
  fillInPOEInput = 'FillInPOEInput',
  addGeneralDocInput = 'AddGeneralDocInput',
  deleteGeneralDocInput = 'DeleteGeneralDocInput',
  editGeneralDocInput = 'EditGeneralDocInput',
  fillInGeneralDocInput = 'FillInGeneralDocInput',
  addStudentDocAnnotation = 'AddStudentDocAnnotation',
  deleteStudentDocAnnotation = 'DeleteStudentDocAnnotation',
  addProgrammeDocAnnotation = 'AddProgrammeDocAnnotation',
  editDocAnnotation = 'EditDocAnnotation',
  deleteProgrammeDocAnnotation = 'DeleteProgrammeDocAnnotation',
  answerQuestion = 'AnswerQuestion',
  selectAnswer = 'SelectAnswer',
  deSelectAnswer = 'DeSelectAnswer',
  addPOEActivity = 'AddPOEActivity',
  addActivityQuestion = 'AddActivityQuestion',
  addQuestionAnswer = 'AddQuestionAnswer',
  editPOEActivity = 'EditPOEActivity',
  editActivityQuestion = 'EditActivityQuestion',
  editQuestionAnswer = 'EditQuestionAnswer',
  deletePOEActivity = 'DeletePOEActivity',
  deleteActivityQuestion = 'DeleteActivityQuestion',
  deleteQuestionAnswer = 'DeleteQuestionAnswer',
  markParagraphAnswer = 'MarkParagraphAnswer',
}
